export function NoPropertiesPanel() {
    return (
        <div className="flex w-full justify-center p-2 text-gray-500">
            {
                <span>Properties are actively being generated, check back momentarily.</span>
            }
        </div>
    )
}